import { inject, Injectable } from '@angular/core';
import { MediaContext } from '../../../models/media-context.model';
import { ConfirmHandler } from '../../dialog/dialog.model';
import { DialogService } from '../../dialog/dialog.service';
import { MediaPickerDialogComponent } from '../media-picker-dialog.component';
import { MediaPickerDialogResult, MediaPickerType } from '../media-picker-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class MediaPickerDialogService {
  private readonly _dialog = inject(DialogService);

  open<M extends boolean | undefined = false>(
    callback: ConfirmHandler<MediaPickerDialogResult<M>>,
    options: {
      type: MediaPickerType | MediaPickerType[];
      multi?: M;
      maxSelectionLimit?: number;
      initialSelectionCount?: number;
      context?: MediaContext;
      unitOnly?: boolean;
      targetUnitId?: string;
      initialViewMode?: 'client' | 'unit' | 'shared' | 'system';
      targetGroupId?: string | null;
    }
  ) {
    const types = Array.isArray(options.type) ? options.type : [options.type];

    return this._dialog.open(
      MediaPickerDialogComponent,
      {
        type: types,
        multiple: options.multi ?? false,
        maxSelectionLimit: options.maxSelectionLimit,
        initialSelectionCount: options.initialSelectionCount,
        context: options.context,
        unitOnly: options.unitOnly,
        targetUnitId: options.targetUnitId,
        initialViewMode: options.initialViewMode,
        targetGroupId: options.targetGroupId,
        onConfirm: callback,
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }
}
